module.exports = __webpack_public_path__ + "static/media/withdrawalHistory.e8f41b0d.svg";